import React, { useState, useEffect } from 'react';
import styles from './otp-verification.module.scss';
import { Input, OTPInput } from '..';
import Button from '../../../../common/ekedc-components/button/Button';

export interface OTPVerificationProps {
  value: string;
  onChange: (value: string) => void;
  onSubmit: () => void;
  onResend: () => void;
  buttonText?: string;
  otpLength?: number;
  resendTimerSeconds?: number;
  disabled?: boolean;
  error?: boolean;
  helperText?: string;
  className?: string;
  type?: 'OTP' | 'TOKEN'
}

const OTPVerification: React.FC<OTPVerificationProps> = ({
  value,
  onChange,
  onSubmit,
  onResend,
  buttonText = 'Continue',
  otpLength = 6,
  resendTimerSeconds = 180,
  disabled = false,
  error = false,
  helperText,
  className = '',
  type = 'OTP'
}) => {
  const [resendTimer, setResendTimer] = useState(resendTimerSeconds);

  const handleTokenChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };

  useEffect(() => {
    if (resendTimer > 0) {
      const timer = setTimeout(() => {
        setResendTimer(prev => prev - 1);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [resendTimer]);

  const handleResend = () => {
    setResendTimer(resendTimerSeconds);
    onResend();
  };

  return (
    <div className={`${styles.verificationContainer} ${className}`}>
      <div className={styles.otpSection}>
        {type === 'OTP' && <OTPInput
          value={value}
          onChange={onChange}
          disabled={disabled}
          error={error}
          length={otpLength}
        /> }
       {type === 'TOKEN' && 
       <Input placeholder='Enter token' value={value} onChange={handleTokenChange} disabled={disabled}  />
}
        {/* {helperText && (
          <p className={`${styles.helperText} ${error ? styles.error : ''}`}>
            {helperText}
          </p>
        )} */}
      </div>

      <div className={styles.resendSection}>
        <p className={styles.resendText}>
          Didn't get Code?{' '}
          {resendTimer > 0 ? (
            <span className={styles.timer}>Resend in {resendTimer}s</span>
          ) : (
            <button
              type="button"
              className={styles.resendButton}
              onClick={handleResend}
            >
              Resend
            </button>
          )}
        </p>
      </div>

      <div className={styles.buttonSection}>
        <Button
          // fullWidth
          variant="primary"
          onClick={onSubmit}
          disabled={disabled || (type === 'OTP' ? value.length !== otpLength : value.length === 0)}
        >
          {buttonText}
        </Button>
      </div>
    </div>
  );
};

export default OTPVerification;